import React, { useEffect } from "react";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";
import { hinge, hingePivot, hingeEmtek, hingeAlumBifold } from "./defaults";

const useHingeSelector = () => {
  const addToQuote = useStore((state) => state.addToQuote);

  const doorType = useStore((state) => state.quote.doorType);
  const material = useStore((state) => state.quote.material);
  const hingeColor = useStore((state) => state.quote.hingeColor);
  const pivotHardware = useStore((state) => state.quote.pivotHardware);
  const dropseal = useStore((state) => state.quote.dropseal);
  const stilesAndRails = useStore((state) => state.quote.stilesAndRails);

  const squareHinges = useStore((state) => state.quote.squareHinges);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const handleClick = (label: string) => {
    const checked = checkMark(label);

    if (checked) {
      addToQuote({ hingeColor: "" }, "hingeColor");
    } else {
      addToQuote({ hingeColor: label });
      if (findRequired("Hinge Color")) removeRequired("Hinge Color");
    }
  };

  const variant = (label: string) =>
    label === hingeColor ? "filled" : "outlined";

  const checkMark = (label: string) => label === hingeColor;

  const heading = doorType === "Pivot" ? "Hinge Plate Color" : "Hinge Color";

  const hasSquareBarrelHinges = doorType === "Swing" && squareHinges;

  const isAlumBifold = material === "All Aluminum" && doorType?.includes("Bi-fold");

  const hingeOptions =
    doorType === "Pivot" || stilesAndRails?.includes("Pico")
      ? hingePivot
      : isAlumBifold
      ? hingeAlumBifold
      : hasSquareBarrelHinges
      ? hingeEmtek
      : hinge;

  return {
    hingeOptions,
    heading,
    handleClick,
    pivotHardware,
    dropseal,
    variant,
    checkMark,
    doorType,
    hingeColor,
    stilesAndRails,
    hasSquareBarrelHinges,
    material,
    isAlumBifold
  };
};

export default useHingeSelector;
